import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import AOS from "aos";
import 'aos/dist/aos.css';
import { useProvider, Toast } from '../context/MenuProvider';



const ChecagemCliente = () => {
  const {
    crudAdmin,
  } = useProvider();
  const { get, loading } = crudAdmin || {};
  const [mais, setMais] = useState(false);
  const [documento, setDocumento] = useState("");
  const [inadimplentes, setInadimplentes] = useState(null);

    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    }, []);
    
  const consultar = async()=>{
    try{
      const docNumeros = documento.replace(/\D/g, '');
      const response = await get(`/gvendas/relatorios/cliente-inadimplente/${docNumeros}/`, 'pagina');
      if(response && response.length){
        setInadimplentes(response[0])
      }
    }catch(err){
      
    }
  }
  
  useEffect(() => {
    const docNumeros = documento.replace(/\D/g, ''); // remove tudo que não for número
    if (docNumeros.length === 11 || docNumeros.length === 14) {
      consultar();
    }
  }, [documento]);
  
  return (<>
    <div className="text-muted mb-3">
      <div>
        Proteja-se de clientes que agem de má fé. Esta funcionalidade analisa e sinaliza inadimplências com base em informações compartilhadas por todos os usuários do app.
      </div>
      {mais?(<>
        <div className="mt-2">
          Funciona assim:
        </div>
        <div>
          O app compara os dados do cliente (telefone, CPF ou CNPJ) com a base de dados geral. Se houver dívidas de longo prazo sem pagamento, o sistema emite um alerta.
        </div>
        <div>
          O alerta será disponível quando:
          <ul>
            <li>O cliente realizar uma compra e não pagar por longo prazo</li>
            <li>Houver mais de 3 meses desde a última compra sem quitação.</li>
          </ul>
        </div>
      </>):(<>
        <Button variant="outline-secondary" onClick={()=>setMais(true)} className="btn-sm mt-2">Saiba mais...</Button>
      </>)}
      
    </div>
    <div>
      <Form.Group controlId="formDocumento" className="mt-3">
                          <Form.Label>Telefone, CPF ou CNPJ</Form.Label>
                          <div className="input-group">
                            <Form.Control 
                                type="number" 
                                value={documento} 
                                onChange={(e) => setDocumento(e.target.value)} 
                            />
                            <Button variant="secondary" onClick={consultar}><i class="bi bi-search"></i></Button>
                          </div>
                          <div className="text-muted small text-center">Sugestões e melhorias para esta função, envie uma mensagem para o whatsapp (11) 96617-5193 suporte do app</div>
                        </Form.Group>
    </div>
    <div className="mt-3 mb-5">
                <div className="list-group mt-3">
                    {inadimplentes?.length > 0 ? (
                      inadimplentes.map((x, index) => (
                        <div data-aos="fade-up" data-aos-delay={parseInt(`${index}00`)}>
                          <RenderizarProduto
                            key={x.id}
                            src={x.foto}
                            lm="mb-1"
                            text1={x.local}
                            text2={`Última compra: ${x.ultima_compra}`}
                            titulo={x.devedor}
                            extra={<div className="text-muted border-top mt-1">
                              <b>Atenção:</b>
                              {` `}{x.devedor}{` deve `}{parseFloat(x.total_divida).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              {` para `}{x.credor}{` a `}{x.ultima_compra}
                            </div>}
                          />
                        </div>
                      ))
                    ):(
                      !loading && inadimplentes !== null && <div data-aos="fade-up" className="text-center border-top mt-2 text-muted">Nenhuma dívida encontrada.</div>
                    )}
                </div>
    </div>
  </>)
}

export default ChecagemCliente